import styled from 'styled-components'

const PageBreakAfterForPrint = styled.div`
  @media print {
    page-break-after: always;
  }
`

export { PageBreakAfterForPrint }
